import { Button, CssBaseline, makeStyles, Typography, List, ListItem, Box, Checkbox } from '@material-ui/core';
import { COLORS } from '../../shared/Theme';

import axios from 'axios';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import ToastStr from '../../request/toastStr';
import { admin as v_admin, basic, Values, SNACKBAR_TIME } from '../../request/values';
import { DialogDeleteClass } from '../../components/Dialog';
import { SubAdminHeaderBar } from '../../shared/header/HeaderBar';
import { useCookies } from 'react-cookie';

const SERVER = basic.server;

const useStyles = makeStyles((theme) => ({
	nanumSquare_regular: {
		fontFamily: 'NanumR',
	},
	background: {
		width: '100vw',
		height: '100vh',
		background: `url("/images/background.png")`,
	},
	content: {
		width: '100%',
		height: '100%',
		display: 'grid',
		//gridTemplateColumns: '230px 1fr',
	},
	mainPage: {
		display: 'flex',
		flexDirection: 'column',
		gap: '5vh',
	},
	userinfo: {
		display: 'flex',
		justifyContent: 'center',
		flexDirection: 'column',
		alignItems: 'center',
		border: 'none',
		borderWidth: '0px 0px 1px 0px',
		paddingBottom: '0.5vh',
		'& #name': {
			display: 'inline-block',
			fontFamily: 'NanumR',
			fontSize: '1.25rem',
			fontWeight: 'bolder',
		},
	},
	form: {
		display: 'flex',
		width: '97%',
		height: '5%',
		justifyContent: 'right',
		alignItems: 'center',
		gap: '1%',
		'& input': {
			width: '15%',
			height: '80%',
			paddingLeft: '7px',
		},
		'& Button': {
			//border: 'solid 1px',
			border: 'solid gray 1px',
			height: '90%',
			//borderStyle: 'inset',
			//backgroundColor: '-webkit-control-background',
		},
	},
	table: {
		display: 'grid',
		gridTemplateRows: '50px 1fr',
		width: '94%',
		height: '60vh',
		margin: '1% 3%',
		borderBottom: '2px solid black',
		//border: 'solid 2px',
		//borderRadius: '10px 10px 0 10px',
		'& #title': {
			display: 'grid',
			gridTemplateColumns: '1fr 3fr 4fr 2fr 3fr 17px',
			border: 'solid',
			borderWidth: '0 0 2px 0',
			'& span': {
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				'& p': {
					fontSize: '1.15rem',
					fontWeight: 'bolder',
				},
			},
		},
		'& #classinfo': {
			overflow: 'scroll',
			overflowX: 'hidden',
			borderRadius: '0 0 0 10px',
		},
		'& ul': {
			padding: '0',
		},
		'& li': {
			border: 'solid gray',
			borderWidth: '0 0 1px 0',
		},
	},
	manageClass: {},
	classInfo: {
		display: 'grid',
		gridTemplateColumns: '1fr 3fr 4fr 2fr 3fr 17px',
		padding: '25px 0',
		backgroundColor: `${COLORS.WHITE}`,
	},
	textLabel: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		color: `${COLORS.CHARCHOAL_GREY}`,
		fontSize: '1rem',
		fontFamily: 'NanumB',
		//fontWeight: 'bold',
		lineHeight: '21px',
	},
	buttonLabel: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		color: `${COLORS.CHARCHOAL_GREY}`,
		backgroundColor: `${COLORS.BLACK}`,
		fontSize: 18,
		fontColor: 'black',
		fontFamily: 'NanumB',
		fontWeight: 'bold',
		lineHeight: '21px',
	},
	infoButton: {
		borderWidth: 1,
		borderStyle: 'solid',
		borderColor: `${COLORS.WHITE}`,
		backgroundColor: `${COLORS.WATER_BLUE}`,
		borderRadius: '10px',
		margin: '0.5vh',
		width: '8vw',
		//transition: 'opacity 3s',
		opacity: 1,
	},
	deleteButton: {
		borderWidth: 1,
		borderStyle: 'solid',
		borderColor: `${COLORS.WHITE}`,
		backgroundColor: `${COLORS.PUMPKIN}`,
		borderRadius: '10px',
		margin: '0.5vh',
		width: '8vw',
	},
	buttonFont: {
		color: `${COLORS.WHITE}`,
		fontSize: '0.8vw',
	},
	buttonFontBlue: {
		transitionDuration: '0.5s',
		color: `${COLORS.WATER_BLUE}`,
		fontSize: '0.8vw',
	},
	buttonFontPumpkin: {
		transitionDuration: '0.5s',
		color: `${COLORS.PUMPKIN}`,
		fontSize: '0.8vw',
	},
	blank: {
		display: 'flex',
		height: '40px',
	},
	classStart: {
		float: 'right',
		margin: '5px 3%',
		padding: '5px 25px',
		color: `${COLORS.WHITE}`,
		borderRadius: '5px',
		backgroundColor: `${COLORS.WATER_BLUE}`,
		'&:hover': {
			color: `${COLORS.WATER_BLUE}`,
			backgroundColor: 'inherit',
		},
	},
	classClose: {
		float: 'right',
		margin: '5px 3%',
		padding: '5px 25px',
		color: `${COLORS.WHITE}`,
		borderRadius: '5px',
		backgroundColor: `#f50057`,
		'&:hover': {
			color: `#f50057`,
			backgroundColor: 'inherit',
		},
	},
}));

type iClassList = {
	class_code: string;
	class_name: string;
	class_country: string;
	start_date: string;
	reg_date: string;
};

const SubAdminManageClass: React.FC<any> = (props) => {
	const classes = useStyles();
	let history = useHistory();

	const { member, deleteMember } = props;

	const [classList, setClassList] = useState<iClassList[]>([]);
	const [cookies, setCookie, removeCookie] = useCookies();
	const [targetClassName, setTargetClassName] = useState<any | null>();
	const [menu, setMenu] = useState<boolean>(false);
	const [checkedCodes, setCheckedCodes] = useState<String[]>([]);
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();
	const [operMenu, setOperMenu] = useState<boolean>(false);

	const valueChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { id, value } = e.target;
		if (id == 'targetClassName') setTargetClassName(value);
	};

	const handleCheckboxChange = (classCode: String, isChecked: boolean) => {
		setCheckedCodes((prev: any) => {
			if (isChecked) {
				return [...prev, classCode];
			} else {
				return prev.filter((code: String) => code !== classCode);
			}
		});
	};

	const searchControl = () => {
		if (targetClassName == '') getClassContent();
		else searchClassContent();
	};

	const searchClassContent = () => {
		let url = new URL(SERVER + v_admin.admin + v_admin.search_class);
		let params = {
			id: member.id.toString(),
			targetClassName: targetClassName.toString(),
		};
		url.search = new URLSearchParams(params).toString();
		axios({
			method: 'GET',
			withCredentials: true,
			//url: SERVER + v_admin.admin + v_admin.search_class,
			url: url.toString(),
		})
			.then((res) => {
				return res.data;
			})
			.then((data: any) => {
				console.log('data?', data);
				if (data.code == Values.SUCCESS_CODE) {
					setClassList(data.data);
				}
				if (data.code == Values.FAIL_CODE) {
					setClassList([]);
				}
			});
	};

	const getClassContent = () => {
		let url = new URL(SERVER + v_admin.admin + v_admin.class_list);
		let params = { id: member.id.toString() };
		url.search = new URLSearchParams(params).toString();
		axios({
			method: 'GET',
			withCredentials: true,
			//url: SERVER + v_admin.admin + v_admin.class_list,
			url: url.toString(),
		})
			.then((res) => {
				return res.data;
			})
			.then((data: any) => {
				console.log('data?', data);
				if (data.code == Values.SUCCESS_CODE) {
					setClassList(data.data);
				}
			});
	};

	const postClassEnd = (event: any) => {
		if (checkedCodes === undefined || checkedCodes.length === 0)
			enqueueSnackbar(ToastStr.CLASS_CHECKED_STR, {
				variant: 'warning',
				autoHideDuration: SNACKBAR_TIME,
			});
		else {
			axios({
				method: 'POST',
				data: {
					class_codes: checkedCodes,
				},
				withCredentials: true,
				url: SERVER + v_admin.admin + v_admin.class_end,
			})
				.then((res) => {
					return res.data;
				})
				.then((data: any) => {
					console.log(data);
					console.log(data.code);
					if (data.code == Values.SUCCESS_CODE) {
						enqueueSnackbar(ToastStr.CLASS_END_SUCCESS_STR, {
							variant: 'success',
							autoHideDuration: SNACKBAR_TIME,
						});
					} else {
						if (data.code == Values.FAIL_CODE) {
							enqueueSnackbar(ToastStr.CLASS_END_FAIL_STR, {
								variant: 'warning',
								autoHideDuration: SNACKBAR_TIME,
							});
						} else {
							enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
								variant: 'error',
								autoHideDuration: SNACKBAR_TIME,
							});
						}
					}
				})
				.then(() => {
					getClassContent();
					setCheckedCodes([]);
				});
		}
	};

	const postClassStart = (event: any) => {
		if (checkedCodes === undefined || checkedCodes.length === 0)
			enqueueSnackbar(ToastStr.CLASS_CHECKED_STR, {
				variant: 'warning',
				autoHideDuration: SNACKBAR_TIME,
			});
		else {
			axios({
				method: 'POST',
				data: {
					class_codes: checkedCodes,
				},
				withCredentials: true,
				url: SERVER + v_admin.admin + v_admin.class_start,
			})
				.then((res) => {
					return res.data;
				})
				.then((data: any) => {
					console.log(data);
					console.log(data.code);
					if (data.code == Values.SUCCESS_CODE) {
						enqueueSnackbar(ToastStr.CLASS_START_SUCCESS_STR, {
							variant: 'success',
							autoHideDuration: SNACKBAR_TIME,
						});
					} else {
						if (data.code == Values.FAIL_CODE) {
							enqueueSnackbar(ToastStr.CLASS_START_FAIL_STR, {
								variant: 'warning',
								autoHideDuration: SNACKBAR_TIME,
							});
						} else {
							enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
								variant: 'error',
								autoHideDuration: SNACKBAR_TIME,
							});
						}
					}
				})
				.then(() => {
					getClassContent();
					setCheckedCodes([]);
				});
		}
	};

	useEffect(() => {
		getClassContent();
	}, []);

	return (
		<div className={classes.background}>
			<CssBaseline />
			<div className={classes.content}>
				<div className={classes.mainPage}>
					<SubAdminHeaderBar member={member} />
					<div className={classes.manageClass}>
						<div className={classes.form}>
							<input
								type="text"
								placeholder="검색할 교육명을 입력해주세요."
								id="targetClassName"
								onChange={valueChangeHandler}
								onKeyDown={(e) => {
									if (e.key === 'Enter') {
										searchControl();
									}
								}}
							/>
							<Button onClick={searchControl}>
								<Typography>검색</Typography>
							</Button>
						</div>
						<div>
							<div className={classes.table}>
								<div id="title">
									<span></span>
									{/* <span>
                                        <Typography>교육 날짜</Typography>
                                    </span> */}
									<span>
										<Typography>클래스 코드</Typography>
									</span>
									<span>
										<Typography>교육명</Typography>
									</span>
									<span>
										<Typography>진행 상황</Typography>
									</span>
								</div>
								<List id="classinfo">
									{classList != null &&
										classList.map((item: any, index: number) => {
											return (
												<AppListItem
													index={index}
													startDate={item.start_date}
													code={item.class_code}
													name={item.class_name}
													status={item.class_status}
													getclass={getClassContent}
													checked={checkedCodes.includes(item.class_code)}
													onCheckboxChange={handleCheckboxChange}
												/>
											);
										})}
									<div className={classes.blank}></div>
								</List>
							</div>
							<Button className={classes.classClose} onClick={postClassEnd}>
								<Typography>클래스 종료하기</Typography>
							</Button>
							<Button className={classes.classStart} onClick={postClassStart}>
								<Typography>클래스 시작하기</Typography>
							</Button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const AppListItem: React.FC<any> = (props) => {
	const { index, code, name, status, getclass, checked, startDate } = props;
	const [dialogState, setDialogState] = useState(false);
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();
	const [infoButton, setInfoButton] = useState<boolean>(false);
	const [deleteButton, setDeleteButton] = useState<boolean>(false);
	const [isChecked, setIsChecked] = useState(checked);
	const classes = useStyles();
	let history = useHistory();

	let msg = '';
	if (status == 'finish') {
		msg = '교육 완료';
	} else if (status == 'ing') {
		msg = '교육중';
	} else {
		msg = '교육 전';
	}

	const handleClose = () => {
		setDialogState(false);
	};

	const handleOpen = () => {
		console.log('in handleOpen');
		if (!dialogState) {
			setDialogState(true);
		}
	};
	useEffect(() => {
		setIsChecked(checked);
	}, [checked]);

	const handleCheckboxChange = (event: any) => {
		setIsChecked(event.target.checked);
		props.onCheckboxChange(code, event.target.checked);
	};

	const movePage = () => {
		history.push({
			pathname: '/subAdminClassManageNav',
			state: {
				// location state
				code: code,
				name: name,
			},
		});
	};
	/*
    const getClassDeleteConfirm = () => {
        const member = getMember();        
        let url = new URL(basic.server + v_member.member + v_member.license_rnd_confirm);
        let params = {
            'companyNum': member.companyNum.toString(), 'classCode': member.classCode.toString(),
            'licenseNum': props.licenseNum.toString(), 'licensePrice': props.licensePrice.toString(),
            'licenseStatus': props.licenseStatus.toString(), 'email': member.id,
            'name': member.name
        }
        url.search = new URLSearchParams(params).toString();

        console.log(url)
        // fetch(url.toString()).then((res) => {
        //     return res.json()
        // })
        axios({
            method: "GET",
            withCredentials: true,
            url: url.toString(),
        })
            .then(res => res.data)
            .then((data: any) => {
                console.log(data)
                if (data.code == Values.SUCCESS_CODE) {
                    // enqueueSnackbar('success', {variant:'success'})
                     handleOpen()
                } else if (data.code == Values.FAIL_CODE) {
                    enqueueSnackbar(Values.FAIL_MESSAGE, { variant: 'warning', autoHideDuration: SNACKBAR_TIME })
                } else if (data.code == Values.CLASS_NO_START_CODE) {
                    enqueueSnackbar(Values.CLASS_NO_START_MESSAGE, { variant: 'warning', autoHideDuration: SNACKBAR_TIME })
                } else if (data.code == Values.CLASS_FINISH_CODE) {
                    enqueueSnackbar(Values.CLASS_FINISH_MESSAGE, { variant: 'warning', autoHideDuration: SNACKBAR_TIME })
                } else if (data.code == Values.EXCEPTION_CODE) {
                    enqueueSnackbar('에러가 발생하였습니다.', { variant: 'error', autoHideDuration: SNACKBAR_TIME })
                }
            })
    }
*/
	const getClassDelete = (e: any) => {
		let url = new URL(basic.server + v_admin.admin + v_admin.class_delete);
		axios({
			method: 'POST',
			withCredentials: true,
			url: url.toString(),
			data: {
				class_code: code,
			},
		})
			.then((res) => res.data)
			.then((data: any) => {
				console.log(data);
				if (data.code == Values.SUCCESS_CODE) {
					enqueueSnackbar('클래스를 삭제했습니다.', {
						variant: 'success',
						autoHideDuration: SNACKBAR_TIME,
					});
					getclass();
					//props.setLicenseStatus(e, 'complete', data.regDate, data.now)
				} else if (data.code == Values.FAIL_CODE) {
					if (data.msg)
						enqueueSnackbar(data.msg, {
							variant: 'warning',
							autoHideDuration: SNACKBAR_TIME,
						});
					else
						enqueueSnackbar('클래스 삭제 요청에 실패했습니다.', {
							variant: 'warning',
							autoHideDuration: SNACKBAR_TIME,
						});
				} else {
					if (data.msg) enqueueSnackbar(data.msg, { variant: 'error' });
					else
						enqueueSnackbar('클래스 삭제 과정에서 오류가 발생했습니다.', {
							variant: 'error',
							autoHideDuration: SNACKBAR_TIME,
						});
				}
			});
		handleClose();
	};

	return (
		<ListItem id={index} className={classes.classInfo}>
			<Checkbox checked={isChecked} onChange={handleCheckboxChange} inputProps={{ 'aria-label': 'primary checkbox' }} />
			{/* <Box className={classes.textLabel}>{startDate}</Box> */}
			<Box className={classes.textLabel}>{code}</Box>
			<Box className={classes.textLabel}>{name}</Box>
			<Box className={classes.textLabel}>{msg}</Box>
			<Box className={classes.buttonLabel}>
				<Button onClick={(e) => movePage()} onMouseOver={() => setInfoButton(true)} onMouseOut={() => setInfoButton(false)} className={classes.infoButton}>
					<Typography className={infoButton ? classes.buttonFontBlue : classes.buttonFont}>상세보기</Typography>
				</Button>
				<Button className={classes.deleteButton} onMouseOver={() => setDeleteButton(true)} onMouseOut={() => setDeleteButton(false)} onClick={handleOpen}>
					<Typography className={deleteButton ? classes.buttonFontPumpkin : classes.buttonFont}>교육 삭제하기</Typography>
				</Button>
				<DialogDeleteClass
					open={dialogState}
					handleClose={handleClose}
					title={'클래스를 삭제하시겠습니까?'}
					context={`클래스 명 : ${name}`}
					yesConfirm={getClassDelete}
					noConfirm={handleClose}
				/>
			</Box>
		</ListItem>
	);
};

export default SubAdminManageClass;
